import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

// Helper function to get auth headers
const getAuthHeaders = () => {
  const authToken = localStorage.getItem('authToken');
  return {
    'Authorization': authToken ? `Bearer ${authToken}` : ''
  };
};

const SupplierController = {
  /**
   * Fetch suppliers with pagination
   * @param {number} pageNumber - Page number to fetch
   * @param {number} pageSize - Number of items per page
   * @param {string} searchTerm - Optional search term
   * @returns {Promise<Object>} - The paginated suppliers data
   */
  fetchSuppliers: async (pageNumber = 1, pageSize = 10, searchTerm = '') => {
    try {
      let url = `${API_URL}/Fournisseur/Pagination?Size=${pageSize}&PageNumber=${pageNumber}`;
      
      if (searchTerm) {
        url += `&Search=${encodeURIComponent(searchTerm)}`;
      }
      
      // Add auth headers to request
      const response = await axios.get(url, {
        headers: getAuthHeaders()
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching suppliers:', error);
      throw error;
    }
  },

  fetchAllSuppliers: async (searchTerm = '') => {
    try {
      let url = `${API_URL}/Fournisseur`;
      
      if (searchTerm) {
        url += `&Search=${encodeURIComponent(searchTerm)}`;
      }
      
      // Add auth headers to request
      const response = await axios.get(url, {
        headers: getAuthHeaders()
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching suppliers:', error);
      throw error;
    }
  },

  /**
   * Create a new supplier
   * @param {Object} supplierData - The supplier data to create
   * @returns {Promise<Object>} - The created supplier
   */
  createSupplier: async (supplierData) => {
    try {
      // Add auth headers to request
      const response = await axios.post(`${API_URL}/Fournisseur`, supplierData, {
        headers: getAuthHeaders()
      });
      return response.data;
    } catch (error) {
      console.error('Error creating supplier:', error);
      throw error;
    }
  },

  /**
   * Update an existing supplier
   * @param {Object} supplierData - Contains id and updated data
   * @returns {Promise<Object>} - The updated supplier data
   */
  updateSupplier: async (supplierData) => {
    try {
      // Add auth headers to request
      const response = await axios.put(`${API_URL}/Fournisseur`, supplierData, {
        headers: getAuthHeaders()
      });
      return response.data;
    } catch (error) {
      console.error(`Error updating supplier #${supplierData.id}:`, error);
      throw error;
    }
  },

  /**
   * Delete a supplier by ID
   * @param {number} id - The ID of the supplier to delete
   * @returns {Promise<Object>} - Response from the API
   */
  deleteSupplier: async (id) => {
    try {
      // Add auth headers to request
      const response = await axios.delete(`${API_URL}/Fournisseur/${id}`, {
        headers: getAuthHeaders()
      });
      return response.data;
    } catch (error) {
      console.error(`Error deleting supplier #${id}:`, error);
      throw error;
    }
  },

  /**
   * Get a supplier by ID
   * @param {number} id - The ID of the supplier to fetch
   * @returns {Promise<Object>} - The supplier data
   */
  getSupplierById: async (id) => {
    try {
      // Add auth headers to request
      const response = await axios.get(`${API_URL}/Fournisseur/ById/${id}`, {
        headers: getAuthHeaders()
      });
      return response.data;
    } catch (error) {
      console.error(`Error fetching supplier #${id}:`, error);
      throw error;
    }
  }
};

export default SupplierController;